module.exports = __webpack_public_path__ + "static/img/Image_about-002.a3741a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Image_about-002.png
// module id = JM/g
// module chunks = 1